import React from "react";
import { empiTheme } from "./styles/empiTheme";

export default function Problem() {
  return (
    <section style={section}>
      <div style={wrap}>
        <div style={eyebrow}>The problem</div>
        <h2 style={h2}>Most of us try to live the same way every day.</h2>

        <p style={lead}>But our bodies don’t.</p>

        <p style={bodyText}>
          Some days feel energetic and clear. Other days feel slow, foggy, or
          heavy — and we wonder what’s wrong with us.
        </p>

        <p style={bodyText}>
          Often, what feels confusing is simply your body moving through natural
          rhythms. EmPi helps you understand them — and work with them.
        </p>
      </div>
    </section>
  );
}

const section = {
  padding: empiTheme.layout.sectionPadding,
  background: empiTheme.colors.background,
};

const wrap = {
  maxWidth: empiTheme.layout.maxWidth,
  margin: "0 auto",
};

const eyebrow = {
  ...empiTheme.typography.eyebrow,
  color: empiTheme.colors.textSecondary,
  marginBottom: 12,
};

const h2 = {
  fontSize: empiTheme.typography.h2.fontSize,
  lineHeight: empiTheme.typography.h2.lineHeight,
  margin: "0 0 16px",
  color: empiTheme.colors.text,
  maxWidth: 760,
};

const lead = {
  fontSize: 20,
  lineHeight: 1.65,
  margin: "0 0 14px",
  color: empiTheme.colors.text,
};

const bodyText = {
  fontSize: empiTheme.typography.body.fontSize,
  lineHeight: 1.7,
  margin: "0 0 14px",
  color: empiTheme.colors.text,
  maxWidth: 760,
};
